import { render, staticRenderFns } from "./PrivilegeEditor.vue?vue&type=template&id=75c095d8&scoped=true"
import script from "./PrivilegeEditor.vue?vue&type=script&lang=js"
export * from "./PrivilegeEditor.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeEditor.vue?vue&type=style&index=0&id=75c095d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c095d8",
  null
  
)

export default component.exports